import React,{useEffect,useState} from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link } from "react-router-dom";

const CEMDashboard = () => {
    const[isLoading,setIsLoading] =useState(false)
    const [data, setData] = useState([]);
  
    var roleID =localStorage.getItem("roleID");
    var guid =localStorage.getItem("guid");

    return (


        <ConsultantLayout>

             <div className='container'>
<div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <h2 className="" style={{color:"#00a7ac"}} >Dashboard</h2>
          

           </div>
           
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3 ' >
            {/* <div style={{float:"right"}}>
            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Profile</Tooltip>)}> 

                       <Link to="/Employer/Profile"> <button className="btn btn-primary mr-3"  btn-ype="button"><i class="fa fa-plus"></i></button>
           </Link>
           </OverlayTrigger>
           
  
          </div> */}
           </div>
           </div>
<hr />
<div class="row mt-5">
 
<div class="col-sm-12 col-lg-4 col-xl-4">
  <Link to="/Employer/Profile" >
        <div class="card shadow-sm p-3 text-center mt-3 " style={{borderTop:'4px solid #00a7ac',borderRadius:'20px',borderLeft:'none',borderRight:'none',borderBottom:'none',height:'150px'}}>
        <div class="text-center">
       <i class="fa fa-user mt-2" style={{color:'#00a7ac',fontSize:'30px'}}></i>

       </div>
            <h4>My Profile</h4>
        </div>
        </Link>
  </div>
  <div class="col-sm-12 col-lg-4 col-xl-4">
  <Link to="/Employer/ListOfLeads" >
        <div class="card shadow-sm p-3 text-center mt-3 " style={{borderTop:'4px solid #00a7ac',borderRadius:'20px',borderLeft:'none',borderRight:'none',borderBottom:'none',height:'150px'}}>
        <div class="text-center">
       <i class="fa fa-users mt-2" style={{color:'#00a7ac',fontSize:'30px'}}></i>

       </div>
            <h4>Leads</h4>
        </div>
        </Link>
  </div>
</div>


</div>
        

        </ConsultantLayout>
    )
}

export default CEMDashboard;